<template>
    <v-card style="border:0px solid pink;">

        <!-- <button 
            type="button"    
            @click="hasHistory() 
                ? $router.go(-1) 
                : $router.push('/')" class="my-5 btn btn-outline-success">&laquo; 
            Back
        </button> -->

        <!-- <button type="button" @click="onBack()">Back</button> -->

        <v-list class="ma-0 pa-2" style="border:0px solid green;" >
            <v-subheader class="title" >Points</v-subheader>

            <!-- <v-btn color="primary" small @click="collapseAll">Collapse All</v-btn> -->

            <v-icon style="float:right" large color="green darken-2" @click="onRefresh">mdi-refresh</v-icon>

            <v-data-table ref="expandableTable" :headers="headers" :items="data" hide-default-footer item-key="equipment_name" :single-expand=true :items-per-page="items_per_page">

            <!-- eslint-disable-next-line -->
            <!-- <template v-slot:group.header="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length">
                <v-btn @click="toggle" x-small icon :ref="group">
                    <v-icon v-if="isOpen">mdi-plus</v-icon>
                    <v-icon v-else>mdi-minus</v-icon>
                </v-btn>
                <span class="mx-5 font-weight-bold">{{ group }}</span>
            </td>
            </template> -->

          </v-data-table>
          
        </v-list>    
    </v-card>
</template>


<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import { DateTime } from "luxon";
import axios from 'axios';
import VueAxios from 'vue-axios';
import { EnergyDisplay } from '../interfaces';
import { IRefLastValue, IRefInfo } from '@/main';

@Component({
    components: {},
})
export default class Points extends Vue {

    public $refs!: {
        expandableTable: any;
    };

    @Prop() public selectedSiteGroup!: string;
    @Prop() public site_ref!: string;
    @Prop() public equip_ref!: string;

    private clockHandler: any;
    private points: Map<string, IRefInfo> = new Map();
    private last_values: Map<string, IRefLastValue> = new Map();
    private data: any[] = [];
    private items_per_page: number = -1;

    private headers = [
    {
      text: 'Point',
      align: 'left',
      sortable: true,
      value: 'point_namespace',
    },
    { text: 'Last Datetime', units: '', align: 'left', value: 'datetime' },
    { text: 'Last Value', units: '', align: 'left', value: 'value' },
    { text: 'Status', units: '', align: 'left', value: 'status' },
    // { text: 'Site', units: '', align: 'left', value: 'site' },
    // { text: 'Energy', units: '(kWh / m²  / year)', align: 'center', value: 'energy_12months' },
  ];

    public async created() {
        this.page_load();
    }

    public async onRefresh() {
        this.page_load();
    }

    public async page_load() {

        const self = this;
        self.data = [];
        const payload = {carnego_site_group_ref: '@' + self.selectedSiteGroup, requested_site_ref: self.site_ref, requested_equipemnt_ref: self.equip_ref};

        self.points = await self.$store.cache.dispatch('getRefsFromSiteGroupSitesAndNames', payload);

        console.log([...self.points.entries()]);

        self.last_values = await self.$store.dispatch('requestLastValuesForSiteGroupRefMap', payload);

        console.log("last_values", [...self.last_values.entries()]);

        const groupBy = (xs: IRefInfo[], key: string) => {
            return xs.reduce((rv, x) => {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
            };

        // const points_grouped_by_equip = groupBy(Array.from(self.points.values()), 'equip_namespace'); // .filter((g) => { ... } );

        for (const p of self.points.values()) {

            const r = self.last_values.get(p.ref);

            let timestamp = DateTime.fromISO('2020-01-01T0:00');
            let value = 'nan';

            if (r !== undefined) {
                
                timestamp = r.timestamp;
                value = r.value.toString();
            } 

            let status = '❌';

            const duration = DateTime.now().diff(timestamp).minutes;

            if (duration < 10) {
                status =  '✅';
            }

            self.data.push(
            {
                point_namespace: p.namespace,
                datetime: timestamp,
                value: value,
                status: status,
            });
        }
    }

    public async mounted() {

        const self = this;

        // Vue.nextTick( () => {
        //     self.collapseAll();
        //     self.collapseAll();
        // });

        setTimeout(() => self.collapseAll(), 500);

        return;
    }

    private expandAll() {
        const self = this;

        for (const name of Object.keys(self.$refs.expandableTable.openCache)) {
            self.$refs.expandableTable.openCache[name] = true;
        }
    }

    private collapseAll() {

        const self = this;

        for (const name of Object.keys(self.$refs.expandableTable.openCache)) {
            self.$refs.expandableTable.openCache[name] = false;
        }
    }

    private hasHistory() {
        return window.history.length > 2;
    }

    // private onBack() {
    //     return window.history.length > 2;
    // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>

